import mfpi_json from '../../plugins/json/index.jsy'
import mfpi_p2p from '../../plugins/p2p-basic/index.jsy'
import mfpi_discovery from '../../plugins/discovery/index.jsy'
import mfpi_direct from '../../plugins/direct/index.jsy'
import mfpi_web from '../../plugins/web/index.jsy'

import FabricHub from './core.jsy'

export default FabricHub.plugin @
  mfpi_json()
  mfpi_p2p()
  mfpi_discovery()
  mfpi_direct()
  mfpi_web()

